export interface DebouncedFn<A extends unknown[]> {
  (...args: A): void;
  cancel: () => void;
}

export const debounce = <A extends unknown[]>(
  fn: (...args: A) => void,
  delay = 300,
): DebouncedFn<A> => {
  let timer: ReturnType<typeof setTimeout> | null = null;

  const debounced = (...args: A): void => {
    if (timer) clearTimeout(timer);
    timer = setTimeout(() => {
      timer = null;
      fn(...args);
    }, delay);
  };

  debounced.cancel = (): void => {
    if (timer) clearTimeout(timer);
    timer = null;
  };

  return debounced;
};
